export default "__VITE_ASSET__CHd7V2$a__"